import { useGGTheme } from 'hooks/theme/useGGTheme';

export function HomeContainer() {
  const {
    components: { Layout },
    pages: { Home },
  } = useGGTheme();

  return (
    <Layout>
      <Home />
    </Layout>
  );
}
